<template>
    <div class="serviceBox">
        <div class="title">
            <p></p>
           <h3>会员充值</h3>
        </div>
        <div class="topUp">
            <p>充值余额：</p>
            <el-input v-model="customBalance" placeholder="请输入充值余额" style="width: 20%" :disabled="!isCustom" type="number"></el-input>
        </div>
        <div class="money">
            <el-radio v-model="selectedAmount" label="100" border @change="handleRadioChange">100元</el-radio>
            <el-radio v-model="selectedAmount" label="500" border @change="handleRadioChange">500元</el-radio>
            <el-radio v-model="selectedAmount" label="1000" border @change="handleRadioChange">1000元</el-radio>
            <el-radio v-model="selectedAmount" label="0" border @change="handleRadioChange">自定义</el-radio>
        </div>
        <div class="typeBox">
            <p>支付方式：</p>
            <el-select v-model="typeValue" placeholder="请选择" style="width: 20%">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="payCode">
            <p>支付二维码：</p>
            <img src="../../assets/img/payCode.png" alt="">
        </div>
<!--        <el-button type="primary" class="btn" @click="handleRecharge">充值余额</el-button>-->
    </div>
</template>

<script>
export default {
    name: 'service',
    data() {
        return {
            // 自定义输入框的值
            customBalance: '',
            // 单选按钮选中的值
            selectedAmount: '',
            // 是否为自定义模式
            isCustom: false,
            typeValue:'1',
            options: [
                {
                    value: '1',
                    label: '微信'
                },
                {
                    value: '2',
                    label: '支付宝'
                }
            ]
        }
    },
    methods:{
        handleRadioChange(value) {
            this.isCustom = value === '0';
            if (!this.isCustom) {
                this.customBalance = this.selectedAmount;
            }else {
                this.customBalance = ''
            }
        },
        handleRecharge(){
            if (this.selectedAmount == ''){
                this.$message.error('请选择充值余额')
                return
            }
            if (this.customBalance == ''){
                this.$message.error('请输入充值余额')
            }
        }
    }
}
</script>

<style scoped>
    .serviceBox{
        background-color: #fff;
        padding: 20px;
        border-radius: 5px;
    }
    .title{
        color: #2d8cf0;
        display: flex;
        align-items: center;
    }
    .title>p{
        margin-right: 10px;
        width: 5px;
        height: 15px;
        background-color: #2d8cf0;
    }
    .topUp, .typeBox, .payCode{
        margin: 10px 20px;
        display: flex;
        align-items: center;
    }
    .money{
        margin: 20px 100px;
    }
    .btn{
        display: block;
        margin: auto;
    }
    .typeBox, .payCode{
        margin: 20px;
    }
</style>